import { logicOr } from './logic';

const BOOL_FILTER_VALUES = {
    TRUE: 1,
    FALSE: 0
};

export const value = valueData => getValueObject(valueData);

export const inRange = (values) => getValueObject({
    type: 'VALUE',
    operator: 'in',
    value: values
});

export const oneOf = (...values) => logicOr(
    ...values.map(valueData  => getValueObject(valueData))
);

const getValueObject = (valueData) => ({ type: 'VALUE', value: valueData });

/* equality functions */

const getEqualityValueFn = operator => valueData => ({
    type: 'VALUE',
    value: {
        value: valueData,
        operator
    }
});

export const greaterThanOrEqual = getEqualityValueFn('gte');
export const greaterThan = getEqualityValueFn('lt');
export const lessThanOrEqual = getEqualityValueFn('lte');
export const lessThan = getEqualityValueFn('lt');
export const equal = getEqualityValueFn('eq');
export const notEqual = getEqualityValueFn('neq');
export const contains = getEqualityValueFn('icontains');

export const isNull = () => ({ // this signature does not match with getEqualityValueFn's signature
    ...getValueObject(BOOL_FILTER_VALUES.TRUE),
    operator: 'isnull'
});
